import type { PermissionOperator } from './PermissionGuard.types';

export function checkPermissions(
  permission: string | string[],
  hasPermission: (name: string) => boolean,
  operator: PermissionOperator = 'every'
): boolean {
  if (typeof permission === 'string') {
    return hasPermission(permission);
  }

  if (permission.length === 0) {
    return false;
  }

  return operator === 'some'
    ? permission.some(hasPermission)
    : permission.every(hasPermission);
}
